import { API } from 'aws-amplify';

export const callLLMCohort = async (prompt: string, filters: any[], page_number: number, sql: string): Promise<string> => {
    const input = {
        prompt: prompt,
        filters: filters,
        page_number: page_number,
        sql: sql,
    };

    try {
        const response: any = await API.post("EDPlatformLLMAPI", "/cohort", {
            body: input,
        });
        console.log('callLLMCohort response', response);
        return response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callLLMCohort");
        return "";
    }
}
